// import BallCanvas from "./canvas/Ball";
import React, { useRef, useEffect } from "react";
import { SectionWrapper } from "../section";
import { styles } from "../styles";
import { technologies } from "../constants/index";
import { motion } from "framer-motion";
import { fadeIn } from "../utils/motion";

const Tech = ({ index }) => {
  const containerRef = useRef(null);

  useEffect(() => {
    const container = containerRef.current;
    let scrollAmount = 0;

    // Speed tuned to match the animation in your MP4
    const SPEED = 0.7; // px per frame ≈ 42px/sec at 60 fps

    function animate() {
      scrollAmount += SPEED;
      container.scrollLeft = scrollAmount;

      if (scrollAmount >= container.scrollWidth / 2) {
        scrollAmount = 0;
      }

      requestAnimationFrame(animate);
    }

    animate();
  }, []);
  return (
    <>
      <motion.div variants={fadeIn("right", "spring", index * 0.5, 0.75)}>
        <h2 className={styles.sectionHeadText}>My Skills</h2>
      </motion.div>
      <div className="w-full py-12 overflow-hidden">
        <div
          ref={containerRef}
          className="flex gap-12 overflow-x-scroll no-scrollbar px-12 py-8"
        >
          {[...technologies, ...technologies].map((skill, idx) => (
            <div
              key={idx}
              className="min-w-[170px] h-[165px] bg-[#121726] 
                        border border-purple-500/20 rounded-2xl 
                        backdrop-blur-xl flex flex-col items-center 
                        justify-center gap-4 
                        transition-all duration-[350ms]
                        hover:-translate-y-[8px]
                        hover:shadow-[0_0_35px_rgba(130,74,255,0.35)]"
            >
              <img
                src={skill.icon}
                alt={skill.name}
                className="w-14 h-14 opacity-90"
              />
              <p className="text-white text-base">{skill.name}</p>
            </div>
          ))}
        </div>
      </div>
    </>
  );

  // return(
  //   <>
  //     <motion.div variants={fadeIn("right", "spring", index * 0.5, 0.75)}>
  //     <h2 className={styles.sectionHeadText}>My Skills</h2>
  //     </motion.div>
  //     <div className="flex flex-row flex-wrap justify-center pt-8 gap-10">
  //       {technologies.map((technology) => (
  //         <div className="flex flex-col items-center gap-8 justify-center w-20" key={technology.name}>
  //           <img className="w-full h-full object-contain" src={technology.icon} alt=""/>
  //           {/* <BallCanvas icon={technology.icon} /> */}
  //           <div className="flex w-max justify-center text-base text-center">{technology.name}</div>
  //         </div>
  //       ))}
  //     </div>
  //   </>
  // )
};
export default SectionWrapper(Tech, "skills");
